import BaseService from '../../BaseService.js';

export default class BenutzerService extends BaseService {
  constructor() {
    super(`benutzer`)
  }
}
